import Swal from "sweetalert2";

export default function swalFormErrorMessage(errors) {
  let message = null;
  if (Array.isArray(errors)) {
    message = errors
      .map(parcel => {
        const keys = Object.keys(parcel);
        if (keys.length === 0) {
          return;
        }

        const error = parcel[keys.at(0)];
        if (error?.message) {
          return error.message;
        }

        return error;
      })
      .filter(item => item)
      .at(0);
  }

  if (!message || typeof message !== "string") {
    message = "لطفا اطلاعات مرسوله را درست تکمیل کنید";
  }

  Swal.fire({
    icon: "error",
    text: message,
    confirmButtonColor: "gray",
    confirmButtonText: "باشه",
  });
}
